import axios from 'axios';
import { TServiceCharge } from '../types';
import { baseUrl_, timeout } from './constants';
import { Request } from '../apis/request';

const pricee = localStorage.getItem('package-price');
const price_ = pricee ?? 'xxx';
const token = localStorage.getItem('login-token');

type TProps = {
  allPackagesAndPrice: TServiceCharge;
  price?: string;
};
type TGetPrice = {
  packageName: string;
  allPackagesAndPrice: TServiceCharge;
};
export const fetchPackages = async () => {
  const res = await Request.get(`/servicechargelogs/active`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('login-token')}`,
      sessId: localStorage.getItem('sessId') ?? '',
    },
    timeout: timeout,
  });
  return res;
};

export const getEntrepreneur = async () => {
  const res = await Request.get(`/user/entrepreneur`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('login-token')}`,
      sessId: localStorage.getItem('sessId') ?? '',
    },
    timeout: timeout,
  });

  return res;
};
